import { createAuth0Client } from '@auth0/auth0-spa-js'
import { emulateUser } from 'stores/auth'
import config from 'services/auth/authConfig'
import { clearSavedStorage } from 'utils/localstorage'
import { userLogout } from 'services/api/apiCalls'
import { websocketStore } from 'stores/webSocket'

const redirectLocation = window.location.origin + '/callback'
let auth0Client = null

async function createClient() {
  if (!config.domain || !config.clientId) {
    throw new Error('UI is missing auth0 config, check pipelines')
  }
  auth0Client = await createAuth0Client({
    domain: config.domain,
    clientId: config.clientId,
    authorizationParams: {
      redirect_uri: redirectLocation,
      audience: 'api.cliniciannexus.com', // TODO: Get back this to: config.audience,
      scope: 'openid profile email offline_access',
      prompt: 'select_account',
    },
    useRefreshTokens: true,
    cacheLocation: 'localstorage',
  })
  return auth0Client
}

async function logout(refresh_token_expired = false) {
  emulateUser.set(null)
  clearSavedStorage(['tutorial-dismissed', 'gridFilters', 'selectedPercentile', 'mpIncumbentAPPXAxis', 'mpIncumbentPhyXAxis'])
  if (!refresh_token_expired) {
    await userLogout()
  }

  websocketStore.update(socket => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.close()
    }
    return null
  })

  return auth0Client.logout({ logoutParams: { returnTo: window.location.origin, federated: true } })
}

async function getUserInfo() {
  const user = await auth0Client.getUser()
  return user.name
}

async function getUser() {
  const user = await auth0Client.getUser()
  return user
}

const auth = {
  createClient,
  logout,
  getUserInfo,
  getUser,
}

export default auth
